import agreementStatuses from "./constants/agreementStatuses";

const terminatableStatuses = [agreementStatuses.SIGNED, agreementStatuses.ACTIVE];

export default function canTerminate(agreement) {
	return terminatableStatuses.includes(agreement.status);
}
